import { useLPQuery } from '../lib/hooks/useLPQuery';

export function useCyberIqSettingsQuery(learnerId: string) {
  return useLPQuery<CyberIqSettingsQueryResponse>(
    ['CyberIqSettingsQuery', learnerId],
    `/cyberiq/${learnerId}/settings`,
  );
}

type CyberIqSettingsQueryResponse = {
  authenticationScheme: string;
  backgroundUrl: string;
  canFlagUsers: boolean;
  canNudgeUsers: boolean;
  canSendCongratulations: boolean;
  canSendGuidance: boolean;
  enableScoreBreakdownCompletion: boolean;
  enableScoreBreakdownEngagement: boolean;
  enableScoreBreakdownKnowledge: boolean;
  enableScoreBreakdownPhishingClicks: boolean;
  enableScoreBreakdownPhishingReports: boolean;
  portalEnabled: boolean;
  reportChannelEmail: boolean;
  reportChannelTeams: boolean;
  reportDay: number;
  reportEndDate: string;
  reportRepeatWeeks: 1;
  reportSendToAllUsers: boolean;
  reportStartDate: string;
  reportTimeAM: boolean;
  signInGuidance: boolean;
  signInGuidanceText: string;
  signInTheme: string;
  userPerformanceReport: boolean;
  voluntaryTraining: boolean;
  voluntaryTrainingModules: [];
};
